var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_273_820)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60ZM47.0621 17.467C46.5423 18.9884 45.4521 20.2796 43.995 21.0997C45.3774 20.945 46.7273 20.5963 48 20.0653C47.0635 21.3845 45.8845 22.5359 44.5184 23.4653C44.5325 23.7469 44.5395 24.0299 44.5395 24.3146C44.5762 29.2804 42.4971 34.0528 38.7673 37.5644C35.0375 41.076 29.9683 43.0337 24.6935 42.9996C20.902 43.0032 17.1897 41.979 14 40.0494C14.553 40.1103 15.1093 40.1404 15.666 40.1397C18.8071 40.1445 21.8585 39.1544 24.3294 37.3287C21.3461 37.2741 18.7286 35.4424 17.8132 32.7688C18.8586 32.9574 19.936 32.9186 20.9632 32.6556C17.7081 32.036 15.3676 29.343 15.367 26.2166V26.1339C16.3349 26.6414 17.4177 26.9237 18.5251 26.9572C15.4628 25.0273 14.5182 21.1906 16.3666 18.1893C19.9083 22.2915 25.1333 24.7855 30.7416 25.0506C30.037 22.1578 31.4767 19.179 34.2563 17.7786C37.0359 16.3783 40.4672 16.9032 42.6329 19.0599C44.195 18.7705 45.693 18.2318 47.0621 17.467Z",
    fill: "url(#paint0_linear_273_820)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_273_820",
    x: -400,
    y: -400,
    width: 860,
    height: 860,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 200
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_273_820"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_273_820",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_273_820",
    x1: 0,
    y1: 0,
    x2: 60,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F83600"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.f8cd801bae446607769fd863e19dc225.svg";
export { ForwardRef as ReactComponent };